import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from '../core/services/tools.service';
import { DOCUMENT, isPlatformBrowser, Location } from '@angular/common';
import { AnalyticsService } from '../core/services/analytics.service';
import { IntlService } from '../core/services/intl.service';

// declare var $crisp: any;

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit {

  constructor(
    private translateService: TranslateService,
    private toolsService: ToolsService,
    private location: Location,
    @Inject(DOCUMENT) private document,
    @Inject(PLATFORM_ID) protected platformId,
    private analyticsService: AnalyticsService,
    private intlService: IntlService) {
  }

  ngOnInit() {
    this.setLanguage();
    this.loadStripe();
  }

  setLanguage() {
    if (isPlatformBrowser(this.platformId) && this.toolsService.localStorageSupport()) {
      const currentUser = JSON.parse(localStorage?.getItem('currentUser'));
      const isMine = currentUser ? this.location.path().includes(currentUser.merchantSlug) : false;


      if (!currentUser || !currentUser.id || !isMine) {
        const userLang = this.intlService.getClientLanguage();
        const availableLanguages = this.intlService.getAvailableLanguageCodes();
        if (availableLanguages.includes(userLang)) {
          this.intlService.setCurrentLanguage(userLang);
        }
        // console.log('userLang:browser', userLang);
      }
    } else {
      const userLang = this.intlService.getCurrentLanguage();
      if (userLang) {
        this.translateService.use(userLang);
        // console.log('userLang:server', userLang);
      }
    }
  }

  loadStripe() {
    if (isPlatformBrowser(this.platformId)) {
      const pageScripts = this.document.getElementsByTagName('script');
      const pageScriptsArray = [...(pageScripts as any)];

      if (pageScriptsArray?.find((v) => v?.src?.includes('stripe'))) {
        return;
      }
      const stripe = this.document.createElement('script');
      stripe.type = 'text/javascript';
      stripe.src = 'https://js.stripe.com/v3/';
      const header = this.document.getElementsByTagName('head')[0];
      header.appendChild(stripe);
    }
  }


}
